import { StepKey } from "@/src/lib/workflows/steps/types";

const caseStepKeys = [
  StepKey.ENSURE_PATIENT,
  StepKey.CLINICIENT_ENSURE_CASE,
  StepKey.CLINICIENT_CONFIGURE_CASE,
  StepKey.CLINICIENT_CASE_DOCUMENT_UPLOAD,
  StepKey.CLINICIENT_DOCUMENT_NOTE,
  StepKey.CLINICIENT_SYNC_INSURANCE,
] as const;
const legacyStepKeys = [...caseStepKeys, StepKey.REFERRAL_SHEET_EXPORT] as const;

const authAndExportKeys = [
  StepKey.CLINICIENT_ENSURE_AUTHORIZATION,
  StepKey.CLINICIENT_AUTHORIZATION_DOCUMENT_UPLOAD,
  StepKey.CLINICIENT_AUTHORIZATION_TASK,
  StepKey.REFERRAL_SHEET_EXPORT,
] as const;

const referralStepKeysBeforeFax = [...caseStepKeys, ...authAndExportKeys] as const;

const caseStepKeysWithInheritance = [
  StepKey.ENSURE_PATIENT,
  StepKey.CLINICIENT_SAME_DAY_CASE_INHERITANCE,
  StepKey.CLINICIENT_ENSURE_CASE,
  StepKey.CLINICIENT_CONFIGURE_CASE,
  StepKey.CLINICIENT_CASE_DOCUMENT_UPLOAD,
  StepKey.CLINICIENT_DOCUMENT_NOTE,
  StepKey.CLINICIENT_SYNC_INSURANCE,
] as const;
const referralStepKeysWithInheritance = [...caseStepKeysWithInheritance, ...authAndExportKeys] as const;

// Phone-first sequences preserved for tasks persisted before the phone-hold step.
const referralStepKeysNoHolds = [StepKey.REQUIRE_PATIENT_PHONE, ...referralStepKeysBeforeFax] as const;
const referralStepKeysCaseHold = [StepKey.REQUIRE_PATIENT_PHONE, ...referralStepKeysWithInheritance] as const;

export const CONFLUENT_REFERRAL_STEP_KEYS = [
  StepKey.CLINICIENT_SAME_DAY_PHONE_INHERITANCE,
  ...referralStepKeysCaseHold,
] as const;

export type ConfluentReferralStepKey = (typeof CONFLUENT_REFERRAL_STEP_KEYS)[number];

export function getConfluentReferralStepKeys(
  persistedStepKeys: readonly string[] = []
): readonly ConfluentReferralStepKey[] {
  // Return the sequence matching an in-flight task's persisted step indices so they aren't reinterpreted.
  if (persistedStepKeys[0] === StepKey.ENSURE_PATIENT) {
    return persistedStepKeys[caseStepKeys.length] === StepKey.REFERRAL_SHEET_EXPORT
      ? legacyStepKeys
      : referralStepKeysBeforeFax;
  }

  if (persistedStepKeys[0] === StepKey.REQUIRE_PATIENT_PHONE) {
    return persistedStepKeys[2] === StepKey.CLINICIENT_ENSURE_CASE ? referralStepKeysNoHolds : referralStepKeysCaseHold;
  }

  return CONFLUENT_REFERRAL_STEP_KEYS;
}
